// File: src/pages/ActivityChatPage.jsx
// -----------------------------------------------------------------------------
// Page "chat expert" – affichage d'un expert (avatar, titre, description) +
// suggestions de questions rapides, zone de saisie partagée
// -----------------------------------------------------------------------------
import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ActivityFeed from '../components/ActivityFeed';
import { ActivityContext } from "../context/ActivityContext";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from 'react-router-dom';

export default function ActivityChatPage() {
  const [chatEnabled, setChatEnabled] = useState(true);
  const [focus, setFocus] = useState(0);
  const navigate = useNavigate();
  const { jobId, gender, type } = useParams();
  const { activityConvs, sendToVF, isWaitingForResponse} = useContext(ActivityContext);

  let activity = activityConvs[`${jobId}/${type}`] || {sessionSlug: '', messages: [], title: ''};

  useEffect(() => {
    setFocus( focus + 1 )
  }, [jobId]);

  function handleSend(message, event) {
    setChatEnabled(false)
    setFocus(focus+1)
    const api_key = type === 'grit-and-fit' ? process.env.REACT_APP_VF_GRITANDFIT_API_KEY : process.env.REACT_APP_VF_QUIZZ_API_KEY
    sendToVF(jobId, type, { type: 'text', payload: message, event }, api_key);
  }

  function shouldEnableChat() {
    setChatEnabled(true)
  }

  return (
    <div className="flex flex-1 flex-col h-dvh w-full items-center py-6 px-4 no-scrollbar">
      <div className="max-w-3xl mb-3 md:pl-6 pl-12 mt-1 flex cursor-pointer w-full" onClick={() => navigate(`/pro/${jobId}/${gender}`)}>
        <div className="flex items-center gap-2 cursor-pointer">
          <ArrowLeft className="w-4 h-4" />
          <div className="text-sm">Tableau de bord</div>
        </div>
      </div>
      <ActivityFeed key={`messageFeed${jobId}${type}`} onSend={handleSend} type={type} isAwaitingResponse={isWaitingForResponse} jobId={jobId} activity={activity} enableChat={shouldEnableChat} />
    </div>
  );
}
